// import BackupNotificationBar from "../../components/BackupNotificationBar";
// import WebTour from "../../components/modal/WebTour";
// import Header from "../Header";
// import SideNav from "../SideNav/index";

// export function Layout({ children }) {
//   return (
//     <div className="flex flex-col min-h-screen">
//       <div className="flex-none">
//         <BackupNotificationBar />
//       </div>
//       <div className="flex flex-col flex-grow gap-2">
//         <Header />
//         <div className="flex flex-grow">
//           <SideNav />
//           <div className="flex-grow overflow-auto px-5">
//             <WebTour />
//             {children}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

import BackupNotificationBar from "../../components/BackupNotificationBar";
import WebTour from "../../components/modal/WebTour";
import Header from "../Header";
import SideNav from "../SideNav/index";

export function Layout({ children }) {
  return (
    <div className="flex flex-col h-screen">
      {/* Notification Bar - Always at the very top */}
      <div className="flex-none">
        <BackupNotificationBar />
      </div>

      {/* Fixed Header */}
      <div className="flex-none sticky top-0 z-10 bg-white">
        <Header />
      </div>

      {/* Main Content Area with SideNav and scrollable content */}
      <div className="flex flex-grow overflow-hidden">
        {/* Side Navigation */}
        <div className="flex-none">
          <SideNav />
        </div>

        {/* Scrollable Content Area */}
        <div className="flex-grow overflow-auto px-5">
          <WebTour />
          {children}
        </div>
      </div>
    </div>
  );
}
